var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { Button, Icon, Modal, Snackbar, Table, Tooltip } from '@cimpress/react-components';
import 'react-table/react-table.css';
import SearchIcon from '@material-ui/icons/Search';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import * as colors from '@cimpress/react-components/lib/colors';
import { connect } from 'react-redux';
import { toggleCustomBulkExportModal, onExportTypeChange, onExportTypeSubmit, toggleTasksModal, getTasksInfo, handleSearchJobsChange, handleJobDelete } from '../../actions/BulkExportAction';
import '../../styles/export.css';
import { capitalize } from '../../utils/utils';

function mapStateToProps(state) {
  return {
    bulkExport: state.bulkExport
  };
}

var mapDispatchToProps = {
  toggleCustomBulkExportModal: toggleCustomBulkExportModal,
  onExportTypeChange: onExportTypeChange,
  onExportTypeSubmit: onExportTypeSubmit,
  toggleTasksModal: toggleTasksModal,
  getTasksInfo: getTasksInfo,
  handleSearchJobsChange: handleSearchJobsChange,
  handleJobDelete: handleJobDelete
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var jobCompleteIcon = React.createElement("span", {
  className: "status-job-icon"
}, React.createElement(Icon, {
  color: colors.success.base,
  name: "check-circle-2-f"
}));
var jobErrorIcon = React.createElement("span", {
  className: "status-job-icon"
}, React.createElement(Icon, {
  color: colors.danger.base,
  name: "remove-circle-1"
}));
var jobInProgressIcon = React.createElement("span", {
  className: "status-job-icon"
}, React.createElement(Icon, {
  color: colors.teal.base,
  name: "loading-half"
}));

var TasksModal =
/** @class */
function (_super) {
  __extends(TasksModal, _super);

  function TasksModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getIcon = function (status) {
      if (status === 'In Progress') return jobInProgressIcon;
      if (status === 'Error') return jobErrorIcon;
      if (status === 'Completed') return jobCompleteIcon;
      return undefined;
    };

    return _this;
  }

  TasksModal.prototype.render = function () {
    var _this = this;

    var _a = this.props.bulkExport,
        bsStyle = _a.bsStyle,
        tasksList = _a.tasksList,
        showTasksModal = _a.showTasksModal,
        searchJobsString = _a.searchJobsString,
        loadingJobsData = _a.loadingJobsData,
        jobDeletedStatus = _a.jobDeletedStatus;
    var columns = [{
      Header: 'Sku',
      accessor: 'sku',
      style: {
        textAlign: 'left'
      }
    }, {
      Header: 'Date Submitted',
      accessor: 'dateSubmitted',
      style: {
        textAlign: 'center'
      }
    }, {
      Header: 'Status',
      accessor: 'status',
      Cell: function Cell(row) {
        if (row.value === 'Error') {
          return React.createElement(Tooltip, {
            key: row.original.id,
            direction: "right",
            contents: row.original.tooltip ? row.original.tooltip : 'Some error occurred'
          }, _this.getIcon('Error'), React.createElement("span", {
            style: {
              paddingLeft: '3px'
            }
          }, "Error"));
        }

        return React.createElement("span", {
          key: row.original.id,
          style: {
            paddingLeft: '3px'
          }
        }, _this.getIcon(row.value), React.createElement("span", {
          style: {
            paddingLeft: '3px'
          }
        }, row.value));
      }
    }, {
      Header: 'Action',
      style: {
        textAlign: 'left',
        paddingLeft: '4%'
      },
      width: 120,
      sortable: false,
      Cell: function Cell(row) {
        return React.createElement("div", {
          key: row.original.id
        }, React.createElement(Tooltip, {
          direction: "bottom",
          variety: "popover",
          tooltipStyle: {
            overflowX: 'scroll',
            maxHeight: 250
          },
          contents: React.createElement("div", null, React.createElement("p", null, React.createElement("b", null, "Job Id"), ": ", row.original.id), React.createElement("p", null, React.createElement("b", null, React.createElement("u", null, "Selections"))), row.original.possibleValues && Object.keys(row.original.possibleValues).map(function (key, idx) {
            if (!key) {
              return null;
            }

            return (// eslint-disable-next-line react/no-array-index-key
              React.createElement("p", {
                key: row.original.id + "-" + idx
              }, React.createElement("b", null, capitalize(key)), ": \xA0", row.original.possibleValues[key] && Array.isArray(row.original.possibleValues[key]) && row.original.possibleValues[key].join(', '))
            );
          }))
        }, React.createElement(Button, {
          className: "export-info-job-button",
          style: {
            padding: 0
          }
        }, React.createElement(Icon, {
          color: colors.teal.base,
          style: {
            marginRight: '10px',
            marginBottom: '-1px'
          },
          name: "infomation-circle-f"
        }))), React.createElement(Tooltip, {
          direction: "left",
          contents: "Delete Job"
        }, React.createElement(Button, {
          className: "export-delete-job-button",
          style: {
            padding: 0
          },
          onClick: function onClick() {
            _this.props.handleJobDelete(row.original.id);
          }
        }, React.createElement(Icon, {
          color: colors.teal.base,
          style: {
            marginRight: '10px'
          },
          name: "bin-1-f"
        }))), row.original.status === 'Completed' && React.createElement(Tooltip, {
          direction: "right",
          contents: !row.original.s3Link ? 'Failed to fetch the link' : 'Download Excel'
        }, React.createElement(Button, {
          className: "export-download-job-button",
          style: {
            padding: '0 0 0 2px'
          },
          disabled: !row.original.s3Link,
          onClick: function onClick() {
            window.open(row.original.s3Link);
          }
        }, React.createElement(Icon, {
          color: colors.teal.base,
          name: "download-3-f"
        }))));
      }
    }];
    return React.createElement(React.Fragment, null, React.createElement(Modal, {
      bsStyle: bsStyle,
      className: "tasks-modal",
      show: showTasksModal,
      onRequestHide: function onRequestHide() {
        return _this.props.toggleTasksModal(false);
      },
      title: "Jobs Status",
      closeButton: true,
      footer: React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: function onClick() {
          return _this.props.toggleTasksModal(false);
        }
      }, "Close")
    }, React.createElement("div", {
      className: "row tasks-modal-container"
    }, React.createElement("div", {
      className: "col-md-3 stats-container"
    }, React.createElement("div", {
      className: "stats-icon"
    }, jobCompleteIcon, React.createElement("span", {
      className: "status-job-value"
    }, tasksList ? tasksList.filter(function (row) {
      return row.status === 'Completed';
    }).length : 0)), React.createElement("div", {
      className: "stats-icon"
    }, jobInProgressIcon, React.createElement("span", {
      className: "status-job-value"
    }, tasksList ? tasksList.filter(function (row) {
      return row.status === 'In Progress';
    }).length : 0)), React.createElement("div", {
      className: "stats-icon"
    }, jobErrorIcon, React.createElement("span", {
      className: "status-job-value"
    }, tasksList ? tasksList.filter(function (row) {
      return row.status === 'Error';
    }).length : 0))), React.createElement(FormControl, {
      className: "task-search"
    }, React.createElement(Input, {
      id: "adornment-amount",
      value: searchJobsString,
      onChange: function onChange(event) {
        return _this.props.handleSearchJobsChange(event.target.value);
      },
      startAdornment: React.createElement(InputAdornment, {
        position: "start"
      }, React.createElement(SearchIcon, null))
    }))), React.createElement("div", {
      className: "row tasks-table-container"
    }, tasksList ? React.createElement(Table, {
      className: "tasks-table",
      columns: columns,
      data: tasksList,
      condensed: true,
      showPagination: false,
      defaultPageSize: 10,
      loading: loadingJobsData,
      pageSize: tasksList && tasksList.length > 0 ? tasksList.length : 3,
      noDataText: "No jobs found",
      sortable: false
    }) : 'Some Error Occurred')), React.createElement(Snackbar, {
      show: jobDeletedStatus,
      bsStyle: jobDeletedStatus,
      delay: 3000
    }, jobDeletedStatus && jobDeletedStatus === 'success' && 'Successfully deleted job' || jobDeletedStatus === 'danger' && 'An error occurred while deleting the job'));
  };

  return TasksModal;
}(Component);

export default connector(TasksModal);